'use client';

import { TextLink } from '@petsmart-ui/sparky';
import type { ReactNode } from 'react';

import { trackNavigationHeaderClick } from '../../../shared';

const ADOPTION_PATH = '/adoption';

type AdoptionCountLinkProps = {
    children: ReactNode;
};

export function AdoptionCountLink({ children }: Readonly<AdoptionCountLinkProps>) {
    function handleClick() {
        trackNavigationHeaderClick({
            selection: 'adoptions',
            linkUrl: ADOPTION_PATH,
        });
    }

    return (
        <TextLink
            variant="secondary"
            href={ADOPTION_PATH}
            target="_blank"
            rel="noopener noreferrer"
            className="header-adoption-link"
            onClick={handleClick}
        >
            {children}
        </TextLink>
    );
}
